import { render, staticRenderFns } from "./LandPlanting.vue?vue&type=template&id=245d909a&scoped=true"
import script from "./LandPlanting.vue?vue&type=script&lang=js"
export * from "./LandPlanting.vue?vue&type=script&lang=js"
import style0 from "./LandPlanting.vue?vue&type=style&index=0&id=245d909a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d909a",
  null
  
)

export default component.exports